// ============================================================================
// Inventario de SUCURSAL — solo lectura y utilidades. **Nada de aquí mueve stock.**
//
// Limpieza v1 (2026-08-19): se borraron `saveInventory` y `saveInventoryFromOrder`,
// que eran la mecánica vieja de mover stock CEDIS→sucursal. Llevaban meses sin
// consumidores (desde F5 ③ la recepción pasa por el ledger del server) pero
// cargaban la regla que el dueño NO quiere: `if (availableInventory.stock >=
// cantidad)` — o sea, **no recibir si el CEDIS no tenía existencia**. Justo lo
// contrario de la regla vigente (la sucursal SIEMPRE recibe; el CEDIS queda
// negativo y solo avisa). Se van para que nadie las reviva por error.
//
// El stock se mueve SOLO por hechos, y todos viven en el server: recepción, venta,
// conteo físico y ajuste con motivo (`@api/Inventory/InventoryServ`).
// ============================================================================

import { getDocs, query, where } from 'firebase/firestore';
import InputServ from '@api/Inputs/InputServ';
import { Input } from '@api/Inputs/Input';
import { getPosCatalog } from '@api/Catalog/CatalogCache';
import {
    branchOfficeInventoriesRef,
    BranchOfficeInventory,
    withCatalogInput
} from '@api/BranchOfficeInventories/BranchOfficeInventory';

/**
 * Los insumos del catálogo: `catalog/snapshot` (0–1 lecturas, ya en caché en el
 * POS) y, si no se pudo, la colección (~108 + ~10 categorías). Si tampoco, una
 * lista vacía: la pantalla se pinta con los snapshots de los renglones antes que
 * no pintarse.
 */
const getCatalogInputs = async (): Promise<Input[]> => {
    try {
        return (await getPosCatalog()).inputs;
    } catch (error) {
        console.error('No se pudo leer el catálogo para el inventario de sucursal; se intenta la colección', error);
    }
    try {
        return await InputServ.getInputs();
    } catch (error) {
        console.error('No se pudieron leer los insumos; el inventario se pinta con los snapshots', error);
        return [];
    }
};

export default {
    /**
     * Los renglones de la sucursal, cada uno con el insumo DEL CATÁLOGO (plan de
     * inventario F0): el snapshot guardado en el documento nació sin umbrales en 338
     * de 837 renglones y con otro rendimiento en 211, y nadie lo actualiza. Con
     * `fillEmpty`, además, un renglón en cero por cada insumo del catálogo que la
     * sucursal nunca ha tocado (para poder contarlo).
     *
     * Lecturas: los renglones de la sucursal (~85–110) + el catálogo (0–1).
     */
    async getInventory(branchOfficeId: string, fillEmpty?: boolean): Promise<BranchOfficeInventory[]> {
        const queryDoc = query(branchOfficeInventoriesRef, where('branchOfficeId', '==', branchOfficeId));
        const [snapshot, catalogInputs] = await Promise.all([getDocs(queryDoc), getCatalogInputs()]);
        const inventory = withCatalogInput(
            snapshot.docs.map((doc) => doc.data() as BranchOfficeInventory),
            catalogInputs
        );
        if (fillEmpty) {
            catalogInputs.forEach((input) => {
                inventory.push({
                    id: input.id,
                    branchOfficeId,
                    input,
                    stock: 0,
                    currentUnit: 0
                });
            });
        }
        return inventory.filter((v, i, a) => a.findIndex((v2) => v2.input.id === v.input.id) === i);
    }
};
